<template>
    <div>

        <!-- Potientiele dealers -->
        <div class="d-flex align-items-start">
            <h2>
                <i class="fa fa-briefcase"></i>
            </h2>
            <div class="w-100">
                <h2 class="mb-1">
                    Openstaande montages
                </h2>
            </div>
            <div class="ms-auto mt-2">
                <button v-on:click="updateComponentVisability(componentId)" class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#openAssemblies" aria-expanded="true" aria-controls="openAssemblies">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div class="collapse" :class="{'show': componentIsVisable}" id="openAssemblies">

                <div
                    class="messages"
                    v-if="this.items.length !== 0"
                >
                    <div
                        v-for="item in this.items"
                        class="message"
                    >
                        <div class="content hasBeenRead">
                            <div class="d-flex flex-column-reverse flex-sm-row align-items-baseline">
                                <p class="sender">{{ item.team }}</p>
                                <span class="date ms-sm-auto text-end">
                                    {{ item.name }}<br>
                                    &euro; {{ item.date }}
                                </span>
                            </div>
                        </div>
                        <div class="actions">
                            <a :href="'offer?status=&filter=1&order-name='+item.name" target="_blank">
                                <i class="fa fa-external-link"></i>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>

    import {useComponentVisibility} from "../../composables/useComponentVisibility";

    export default {
        name: 'open-assemblies',
        components: {},
        props: {
            isVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                items: [{
                    key: {
                        team: '',
                        date: '',
                        name: '',
                        city: '',
                        phone: '',
                        url: '',
                    }
                }],

                componentId: null,
                componentIsVisable: this.isVisible,
                componentVisibility: useComponentVisibility(),
                loading: true,
            }
        },
        computed: {},
        watch: {},
        methods: {
            updateComponentVisability(component_id) {
                // Toggle the visibility state
                this.componentIsVisable = !this.componentIsVisable;
                axios.get('api/update-component-visability', {
                    params: {
                        component_id:component_id,
                        is_visable: this.componentIsVisable
                    }
                });

                if(this.componentIsVisable) {
                    this.loading = true;
                    this.getOpenAssemblies();
                }
            },
            getOpenAssemblies() {
                axios.get('api/open-assemblies')
                    .then(response => {
                       this.items = response.data.items;

                        this.componentId = response.data.componentId;
                        this.loading = false;
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                    });
            },
        },
        mounted() {
            if(this.isVisible) {
                this.getOpenAssemblies();
            } else {
                this.loading = false;
            }
        },
        created() {},
    }
</script>
